import { FriendRef } from "@dokogd/shared";

export function typeIsNotNone<T>(val: T | null | undefined): val is T {
  return val !== null && typeof val !== "undefined";
}

export function typeIsFriendRef(val: any): val is FriendRef {
  return (
    val &&
    val instanceof Object &&
    typeof val.id === "string" &&
    typeof val.displayName === "string" &&
    (typeof val.avatarId === "string" || val.avatarId === null)
  );
}
